import { PropsWithChildren } from "react";
import styles from "./TagTab.module.scss";
import { NormalButton } from "../Button";
import { EditIcon, PlusIcon } from "../../assets/icons";
import { Logo } from "../Logo";

import { Typography } from "../Typography";
import { innoveraLogoSrc } from "../../const/const";

interface TagTabProps extends PropsWithChildren {
  className?: string;
  logoSrc?: string;
  customTags: boolean;
  addTagClick?: () => void;
}

export function TagTab(props: TagTabProps) {
  const { logoSrc, customTags, children, addTagClick = () => null } = props;

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <Logo logo={customTags ? logoSrc || null : innoveraLogoSrc} className={styles.logo} size="small" />
      </div>
      {children}
      {customTags && (
        <div className={styles.addTagContainer}>
          <div className={styles.divider} />
          <NormalButton
            // leftIcon={<EditIcon className={styles.addTagIcon} />}
            leftIcon={<PlusIcon className={styles.addTagIcon} />}
            variant="tertiary"
            onClick={addTagClick}
            size="small"
            className={styles.addTagButton}
          >
            <Typography color="greyscale900" variant="label-5">
              {/* Manage */}
              Modify Tags
            </Typography>
          </NormalButton>
        </div>
      )}
    </div>
  );
}
